module.exports = __webpack_public_path__ + "img/01—01—Home Network Overview > Internet PopOver > Not Connected.81103041.jpg";